import React from "react"

import { IOneVerifyCoverageResult } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { HtmlHelper } from "../../helpers/html.helper"

export const BlueCardEligibleBadgeElement: React.FunctionComponent<{
    coverageResult: IOneVerifyCoverageResult
}> = props => {
    if (typeof props.coverageResult.bluecardEligible !== "boolean") {
        return null
    }

    const isBlueCardEligible = props.coverageResult.bluecardEligible

    const label = isBlueCardEligible
        ? "BlueCard Eligible"
        : "BlueCard Not Eligible"

    const bgClassName = isBlueCardEligible
        ? // These hex colors are chosen to correspond with BCBS style guides although the guides seem to vary slightly by state
          "bg-[#e5eeff] border-[#9ec0ff]"
        : "bg-brand-paleRed2 border-brand-paleRed010"

    return HtmlHelper.getHtmlWrappedBadge(
        label,
        undefined,
        undefined,
        undefined,
        bgClassName,
    )
}
